import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import LINK from 'constants/link.const';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import linkTo from 'utils/links/linkTo.util';

import {
  changeRepeat,
  changeRepeatFrequency,
  changeRepeatFrequencyType,
  changeRepeatUntil,
  fetchClientDepositDetails,
  getAppointment,
  pickClient,
} from 'booking/actions';
import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import BWContent from 'booking/components/common/BWContent';
import CloseButton from 'booking/components/common/CloseButton';
import { closeUrl } from 'booking/utils';
import { getClientsList } from 'salon/actions';

class AppointmentLoading extends React.Component {
  constructor(props) {
    super(props);
    this.state = { requested: false, openedId: 0 };
  }

  // noinspection JSDeprecatedSymbols
  UNSAFE_componentWillMount() {
    const pathArray = this.props.location.pathname.split('/');

    const appointmentId = this.props.location.pathname.includes('/week/')
      ? parseInt(pathArray[8], 10)
      : parseInt(pathArray[7], 10);

    if (this.props.addedServices.length === 0) {
      this.props.getAppointment(this.props.salonId, appointmentId);
    }

    this.setState({ requested: true });
  }

  // noinspection JSDeprecatedSymbols,JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { openedId: openedIdFromState, requested: requestedFromState } = this.state;
    const { fetchAppointment, history, clientId, salonId, location: nextLocation } = nextProps ?? {};
    const {
      fetchClientDepositDetails,
      changeRepeatUntil,
      changeRepeatFrequency,
      changeRepeatFrequencyType,
      location: prevLocation,
      changeRepeat,
    } = this.props;

    const isWeek = prevLocation.pathname.includes('/week/');
    const [, , , , dateString, stylistId, , idInDay, idInWeek] = nextLocation?.pathname.split('/') ?? [];

    const parsedAppointmentId = fromAnyToInteger(isWeek ? idInWeek : idInDay);

    const appointmentResponse = fetchAppointment?.response;
    const responseAppointmentId = appointmentResponse?.id;

    if (
      requestedFromState &&
      !fetchAppointment.isFetching &&
      appointmentResponse &&
      responseAppointmentId === parsedAppointmentId
    ) {
      // Map repeat data to the local state
      if (appointmentResponse.is_repeating) {
        changeRepeat();
        changeRepeatFrequency(appointmentResponse.frequency);
        changeRepeatFrequencyType(appointmentResponse.frequency_type);
        changeRepeatUntil(appointmentResponse.until);
      }

      history.replace({
        pathname: linkTo({
          pattern: isWeek ? LINK.bookingWeekSummary : LINK.bookingDaySummary,
          params: { salonId, appointmentId: responseAppointmentId, dateString, stylistId },
        }),
        state: nextLocation?.state,
      });
    }

    if (clientId && salonId && responseAppointmentId && responseAppointmentId !== openedIdFromState) {
      fetchClientDepositDetails(salonId, clientId);
      this.setState({ openedId: responseAppointmentId });
    }
  }

  render() {
    return (
      <div>
        <div className="BookingWindow">
          <HeaderWrapper>
            <CloseButton history={this.props.history} close={closeUrl(this.props.location)} />
          </HeaderWrapper>
          <BWContent>
            <div className="booking-loading">
              <div className="loading-wrap">
                <div className="loading-anim">
                  <div className="loading-title">
                    <span>Loading Salon Data</span>
                  </div>
                </div>
                <div className="loading-feedback">
                  {this.props.fetchAppointment.isFetching ? 'Booking appointment' : 'Getting appointment data'}
                </div>
              </div>
            </div>
          </BWContent>
        </div>
      </div>
    );
  }
}

const AppointmentLoadingHoc = connect(
  (state) => ({
    addedServices: state.booking.addedServices,
    fetchAppointment: state.booking.fetchAppointment,
    salonId: state.currentSalon.id,
    clientId: state.booking.client ? state.booking.client.id : '',
    clientDepositData: state.booking.clientDepositData,
    errorMessages: {
      fetchClientDetails: state.booking.clientDepositData.errorMessage,
    },
  }),
  mapActionsToDispatchToProps({
    getAppointment,
    pickClient,
    fetchClientDepositDetails,
    getClientsList,
    changeRepeat,
    changeRepeatFrequency,
    changeRepeatFrequencyType,
    changeRepeatUntil: (until) => changeRepeatUntil(moment(until)),
  }),
)(AppointmentLoading);

export default AppointmentLoadingHoc;
